import { types as t, flow } from 'mobx-state-tree';

import { withEnv } from 'models/withEnv';

export const HRMonitorSettings = t
  .model('HRMonitorSettings', {
    redirectUrl: '',
    hasCompanyId: false,
    loading: false,
  })
  .views(withEnv)
  .actions((self) => ({
    afterCreate() {
      self.auth();
    },
    auth: flow(function* () {
      self.loading = true;
      const res = yield self.env.api.integrations.hrMonitorAuth();
      if (!res.error) {
        if (res.data.redirectUrl) {
          self.redirectUrl = res.data.redirectUrl;
        } else if (res.data.hasCompanyId) {
          self.hasCompanyId = true;
        }
      }
      self.loading = false;
    }),
    setCompanyId: flow(function* (companyId) {
      self.loading = true;
      const res = yield self.env.api.integrations.hrMonitorSetCompanyId(companyId);
      if (res.status === 200) {
        self.redirectUrl = '';
        self.hasCompanyId = true;
        self.env.showSuccess(self.env.t('integrations.hrmonitor.settings.save.success'));
      } else {
        self.env.showError(self.env.t('integrations.hrmonitor.settings.save.error'));
      }
      self.loading = false;
      return res;
    }),
  }));
